import {Controller} from "@hotwired/stimulus"

/**
 * ColumnsController's enhances Turbo for readings & data points pages. Turbo
 * takes care of navigation and form submission but the page needs to reflect
 * the current state of the columns. These pages are laid out in three columns:
 *
 * - months
 * - days in a month
 * - readings for a day
 *
 * The first two columns function as drill down selectors and exactly one item
 * in each column is "active" at any time. The items are links with TS enabled
 * allowing to load only the columns to the right of the clicked one but
 * the item has to be visually marked as active (and other items unmarked).
 *
 *   %li#mims-2023-02{data: {columns_activation_category: 'month'}}
 *    %a{data: {action: 'click->columns#activate', columns_activation_category: 'month'},
 *       href: '/readings?date=2023-02-01'}
 *       February 2023
 *   %li#mims-2023-01{data: {columns_activation_category: 'month'}}
 *    %a{data: {action: 'click->columns#activate', columns_activation_category: 'month'},
 *       href: '/readings?date=2023-01-01'}
 *       January 2023
 *
 * Secondarily, create/update always activates the combination of the record just written. This involves updating history via `HistoryController` and activating the correct items in their respective columns by waiting for activator target to be connected:
 *
 *    %div{data: { columns_target: 'activator', target_id: 'mims-2023-01'}}
 */

export default class extends Controller {
  static targets = ['activator'];
  static classes = [
    'current'
  ];

  activate(e) {
    this._activate(e.currentTarget, e.params.activationCategory);
  }

  activatorTargetConnected(activator) {
    const toActivate = this.element.querySelector(`#${activator.dataset.targetId}`);

    this._activate(toActivate, toActivate.dataset.columnsActivationCategory);
    activator.remove();
  }

  _activate(toActivate, category) {
    this.element.querySelectorAll(this._categorySelector(category)).forEach(el => {
      el.classList.remove(this.currentClass);
    });
    toActivate.closest(this._categorySelector(category)).classList.add(this.currentClass);
  }

  _categorySelector(category) {
    return `[data-columns-activation-category="${category}"]`;
  }
}